RivalIQ.apps.Dashboard.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.SingleWidgetCuration = models.Curation.mixin({
        mixins: {
            single: App.mixins.SingleWidget
        }
    });
});
